import movieTrailer from "movie-trailer";
import React, { useState, useEffect } from "react";
import YouTube from "react-youtube";
import axios from "./axios";
import "./Row.css";
function Row({ title, fetchUrl, isLargeRow }) {
  const posterBaseUrl = "https://image.tmdb.org/t/p/w220_and_h330_face";
  const backdropBaseUrl =
    "https://image.tmdb.org/t/p/w355_and_h200_multi_faces";
  const [movies, setMovies] = useState([]); // using react hook useState, we have an empty movie array
  const [trailerUrl, setTrailerUrl] = useState(""); // using react hook useState, we have an empty trailerUrl string
  // when a row loads we want to fetch the data from the API
  // if we leave the brackets empty, it will run the function once and dont run again
  // if we pass in the movies array, it will run for every single time movie changes , its called dependancy
  useEffect(() => {
    // we cant run an async function directly in the useEffect so , we are creating an internl function and then calling it
    async function fetchData() {
      const request = await axios.get(fetchUrl); // axios is used as an alias to instance defined in axios.js
      console.log(request.data.results);
      setMovies(request.data.results);
      return request;
    }
    fetchData();
  }, [fetchUrl]); // if we are using any variable inside useEffect we need to need to include it here. we need to tell use effect you are using a variable out of the block

  const options = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
    },
  };

  const handleClick = (movie) => {
    if (trailerUrl) {
      setTrailerUrl("");
    } else {
      movieTrailer(movie?.name || movie?.title || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          setTrailerUrl(urlParams.get("v"));
        })
        .catch((error) => console.log(error));
    }
  };
  return (
    <div className="row">
      {/* title*/}
      <h2>{title}</h2>
      <div className={`row__posters ${isLargeRow && "first__row"} `}>
        {movies.map((movie) => (
          <img
            className={`row__poster ${isLargeRow && "row__posterLarge"}`}
            key={movie.id} // we need to add a key to every single movie
            src={
              isLargeRow
                ? posterBaseUrl + movie?.poster_path
                : backdropBaseUrl + movie?.backdrop_path
            }
            alt={movie.name || movie?.title}
            onClick={() => handleClick(movie)}
          />
        ))}
      </div>
      {/* container->posters */}

      {trailerUrl && <YouTube videoId={trailerUrl} opts={options} />}
    </div>
  );
}

export default Row;
